import { render, staticRenderFns } from "./SendMailDialog.vue?vue&type=template&id=0d632582&"
import script from "./SendMailDialog.vue?vue&type=script&lang=js&"
export * from "./SendMailDialog.vue?vue&type=script&lang=js&"
import style0 from "./SendMailDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports